import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import Obfuscate from "react-obfuscate";
import Link from "gatsby-link";

import Main from "../components/Main";
import Article from "../components/Main/Article";
import PageHeader from "../components/Page/PageHeader";
import Content from "../components/Main/Content";
import config from "../../content/meta/config";
import Seo from "../components/Seo";
import Footer from "../components/Footer";

const styles = theme => ({});

const Discreet = () => {
  const data = {
    frontmatter: {
      title: "Discreet head protection",
      description:
        "Discreet head protection for surfing that can go under hats, wetsuit hoods or squid lids.  While none of these options are going to prevent head injury in any way, they might reduce the severity a tad."
    }
  };
  const facebook = {};
  return (
    <Main>
      <Article>
        <PageHeader
          title="Discreet head protection"
          subTitle="Under hat, wetsuit hood, or squid lid"
        />
        <Content>
          <h3>Gamebreaker Stealth Helmet Liner</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895574/project_surf_helmet/stealth_liner_wfskau.png"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>No bulging when sewn in</td>
              <td>Requires sewing or adhesive</td>
            </tr>
            <tr>
              <td>Could achieve near-full coverage</td>
              <td />
            </tr>
          </table>
          <strong>Idea</strong>: The Gamebreaker Stealth Liner made from D3O could be sewn into or
          adhered inside any hat, wetsuit hood or squid lid, providing a little protection with
          little to no hit on surfing performance or looks.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://gamebreaker.com/shop/stealth-helmet-liner/"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://amzn.to/2ZUrOLJ"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h3>2nd Skull Protective Skull Cap</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895626/project_surf_helmet/2nd_skull_cap_btr73l.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Ready to go</td>
              <td>Bulges and moves easily</td>
            </tr>
            <tr>
              <td>Very light, minimal</td>
              <td />
            </tr>
          </table>
          <strong>Recommendation</strong>: Works great under a tight-fitting wetsuit hood.
          Otherwise, it will move and bulge easily. Might be better to place under a tight squid lid
          or{" "}
          <a href="https://amzn.to/37UdB5N" target="_blank">
            indo-style hat
          </a>. Or even under the{" "}
          <Link to="/reviews/dmc-soft-surf-helmet/">DMC Soft Surf Helmet</Link> for a little more
          protection. There's also a{" "}
          <a href="https://amzn.to/2ZXYiVm" target="_blank">
            pro version
          </a>{" "}
          with a slip surface for better rotational protection under hard-shell helmets.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://2ndskull.com/products/black-skull-cap"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://amzn.to/2MCmsBO"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
        </Content>
        {/*<Form />*/}
      </Article>
      <Footer footnote={data} />
      <Seo data={data} facebook={facebook} page />
    </Main>
  );
};

Discreet.propTypes = {
  classes: PropTypes.object.isRequired
};

export default injectSheet(styles)(Discreet);



// WEBPACK FOOTER //
// ./src/pages/discreet.js